import styled from '@emotion/styled';
import { ICoreButtonProps } from '@shared/models/components/ICoreButtonProps';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from './CoreButton';

// TODO Component Refactor: use IconsButton
interface HeaderCreateButtonProps extends Omit<ICoreButtonProps, 'children'> {
    onClick?: () => void;
    href?: string;
    label: string;
    disabled?: boolean;
}
const HeaderCreateButton: React.FC<HeaderCreateButtonProps> = ({ label, disabled, ...restProps }) => {
    const { t } = useTranslation();
    return (
        <AddHeaderContainer>
            <Button $color="dashedAccent" startIcon="plus" {...restProps}>
                {label}
            </Button>
        </AddHeaderContainer>
    );
};

const AddHeaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 16px;
    width: calc(100% - 32);
    > * {
        margin: 4px;
    }
`;
export default HeaderCreateButton;
